export const PLANT = {
    1: {
        id: 1,
        name: `VW Pool Car`,
        rego: `SMRTRK`,
        make: `Volkswagen`,
        model: `Passat`,
        year: `2015`,
    },
    2: {
        id: 2,
        name: `Steven's Car`,
        rego: `HYL268`,
        make: `Nissan`,
        model: `Skyline`,
        year: `2007`,
    },
    3: {
        id: 3,
        name: `Jacob's Car`,
        rego: `CZG115`,
        make: `Volkswagen`,
        model: `Passat`,
        year: `2005`,
    },
    4: {
        id: 4,
        name: `T17`,
        plantType: `Trailer`,
        rego: `TR4IL3R`,
        make: `Kea`,
        model: `Shuttle`,
        year: `2007`,
    },
    5: {
        id: 5,
        name: `Ladder 3`,
        plantType: `Ladder`,
        rego: null,
        make: `Transforma`,
        model: `TX4`,
        year: null,
    },
    6: {
        id: 6,
        name: `Development Car 29`,
        plantType: `Car`,
        isDeleted: false,
        make: `Suzuki`,
        model: `SX4`,
        rego: `ERK328`,
        year: 2008
    },
    7: {
        id: 7,
        name: `Suzuki Pool Car`,
        plantType: `Car`,
        isDeleted: false,
        make: `Suzuki`,
        model: `VITARA`,
        rego: `JJL879`,
        year: 2015
    },
    8: {
        id: 8,
        name: `Marketing Car 107`,
        plantType: `Car`,
        isDeleted: false,
        make: `Mazda`,
        model: `MAZDA3`,
        rego: `FFP654`,
        year: 2010
    },
    9: {
        id: 9,
        name: `Parks Car 12`,
        plantType: `Car`,
        isDeleted: false,
        make: `Toyota`,
        model: `Prius`,
        rego: `GQM685`,
        year: 2012
    },
    10: {
        id: 10,
        name: `Canvas Covered Trailer 1`,
        plantType: `Trailer Canvas Covered`,
        isDeleted: false,
        make: `Trailer`,
        model: `Canvas Trailer`,
        rego: ``,
        year: 1998
    },
    11: {
        id: 11,
        name: `Canvas Covered Trailer 2`,
        plantType: `Trailer Canvas Covered`,
        isDeleted: false,
        make: null,
        model: null,
        rego: null,
        year: null
    },
};



// WEBPACK FOOTER //
// ./scripts/constants/fakeData/plant.js